<template>
    <div class="gcmcn-card entity-card" :class="{'selected-element' : selectedEntityUid === entity.uid}" @click="selectEntity">
        <img :src="entity.logo">
        <ns-loader
            class="card-ns-loader"
            :to-load="toLoad"
            :custom-scope="entityScope"
            @dataFetched="onDataFetched"
        >
            <template slot="loader">
                <loading-template slot="loading"></loading-template>
            </template>
            <template slot="content">
                <div>
                    <div class="title-info">RUNNING FEEDS</div>
                    <div class="value-info">{{ runningFeeds }}</div>
                </div>
                <div>
                    <div class="title-info">NEXT FEED BEGINS IN</div>
                    <next-comming-feed :target-date="nextFeedStartDate"></next-comming-feed>
                </div>
            </template>
        </ns-loader>
        <i
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : selectedEntityUid === entity.uid}"
        ></i>
    </div>
</template>

<script>
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import { NextCommingFeed, LoadingTemplate } from 'gcmcn-common';
import moment from 'moment';
export default {

    components: {
        NextCommingFeed,
        LoadingTemplate,
        NsLoader,
    },

    props: {
        entity: {
            type: Object,
            required: true,
        },
        selectedEntityUid: {
            type: String,
            required: true,
        },
    },

    data (){
        return {
            toLoad: [
                {
                    name: 'runningFeeds',
                    model: 'feeds',
                    stats: true,
                    filters: {
                        archived: false,
                        status: 'RUNNING',
                    }
                },
                // We keep two entrypoints to use different "sort_by"
                {
                    name: 'nextFeed',
                    model: 'feeds',
                    filters: {
                        archived: false,
                        status__in: 'AVAILABLE,STARTING,PREPARING',
                        order: '-start_date',
                        confirmed: false,
                        c_resp_page_size: 1,
                        page: 1,
                    }
                },
                {
                    name: 'nextFeedConfirmed',
                    model: 'feeds',
                    filters: {
                        archived: false,
                        status__in: 'AVAILABLE,STARTING,PREPARING',
                        order: '-confirmed_start_date',
                        confirmed: true,
                        c_resp_page_size: 1,
                        page: 1,
                    }
                },
            ],
            nextFeed: [],
            nextFeedConfirmed: [],
            runningFeeds: 0,
        };
    },

    computed: {
        entityScope (){
            return { 'X-Entity-Uid': this.entity.uid};
        },
        nextFeedStartDate (){
            let nexFeeds = this.nextFeed.concat(this.nextFeedConfirmed);

            // Get feeds starts date
            let feedsStartDates = nexFeeds.map(
                feed => {
                    return moment.utc(feed[feed.confirmed ? 'confirmed_start_date' : 'start_date' ]);
                }
            );
            // Filter only future feeds
            feedsStartDates = feedsStartDates.filter(
                startDate => startDate.isAfter()
            );
            // return null if no feedsStartDates
            if(feedsStartDates.length === 0){
                return null;
            };
            // retrieve closest start date
            let next = moment.min(feedsStartDates);
            if(next.isValid() === false){
                return null;
            }
            return next;
        },
    },

    mounted (){

    },

    methods: {
        onDataFetched (res){
            this.runningFeeds = res.runningFeeds;
            this.$set(this, 'nextFeed', res.nextFeed);
            this.$set(this, 'nextFeedConfirmed', res.nextFeedConfirmed);
        },
        selectEntity (){
            this.$emit('on-select-entity', this.entity);
        },
    },
};
</script>

<style lang="scss">
.entity-card{
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    & + .entity-card{
        margin-top: 15px;
    }
    & > img{
        width: 100px;
    }
    .card-ns-loader{
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-grow: 1;
        .title-info{
            font-size: 9px;
        }
        .value-info{
            font-size: 60px;
            text-align: center;
        }
    }
    .el-icon-arrow-right, .el-icon-arrow-left{
        font-size: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Entities/entity.vue